module.exports = __webpack_public_path__ + "img/under-preparation-icon.ae008b82.svg";